import {
  CoastEnrichment,
  CreateEnrichmentData,
  Enrichment,
} from "../types/enrichment";
import api from "./api";

export const listEnrichment = async (): Promise<Enrichment[]> => {
  const response = await api.get(
    "enriquecimento-p1-:stage/:stage/crm/getEnriquecimento"
  );

  return response.data;
};

export const coastEnrichment = async (id: number): Promise<CoastEnrichment> => {
  const response = await api.get(
    "enriquecimento-p1-:stage/:stage/crm/getPriceEnriquecimento",
    { params: { idProspeccao: id } }
  );

  return response.data;
};

export const createEnrichment = async (
  data: CreateEnrichmentData
): Promise<any> => {
  const enrichmentData = {
    id_prospeccao: data.insight.idListProspectei,
    nome_prospeccao: data.insight.nameList,
    price_enrichment: data.coast,
    quantity_enrichment: data.quantity,
    rule_enrichment: data.rule,
    key: data.key,
  };
  const response = await api.post(
    "enriquecimento-p1-:stage/:stage/crm/postEnriquecimento",
    enrichmentData
  );

  return response.data;
};
